import { render, staticRenderFns } from "./BoxDocumento.vue?vue&type=template&id=07f2a86c&"
import script from "./BoxDocumento.vue?vue&type=script&lang=js&"
export * from "./BoxDocumento.vue?vue&type=script&lang=js&"
import style0 from "./BoxDocumento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports